var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18173 1.32091C3.38435 0.556538 2.1183 0.583296 1.35393 1.38067C0.589559 2.17805 0.616317 3.4441 1.41369 4.20847L4.18173 1.32091ZM18.8183 20.8926C19.6157 21.657 20.8817 21.6302 21.6461 20.8328C22.4104 20.0355 22.3837 18.7694 21.5863 18.005L18.8183 20.8926ZM1.4137 18.7915C0.616318 19.5559 0.58956 20.8219 1.35393 21.6193C2.1183 22.4167 3.38435 22.4435 4.18173 21.6791L1.4137 18.7915ZM21.5863 4.99497C22.3837 4.2306 22.4104 2.96455 21.6461 2.16717C20.8817 1.36979 19.6157 1.34304 18.8183 2.10741L21.5863 4.99497ZM1.41369 4.20847L18.8183 20.8926L21.5863 18.005L4.18173 1.32091L1.41369 4.20847ZM4.18173 21.6791L21.5863 4.99497L18.8183 2.10741L1.4137 18.7915L4.18173 21.6791Z",
    fill: "#282829"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.44d2a857390094981a57c4f156a56d19.svg";
export { ForwardRef as ReactComponent };